import type { SVGProps } from "react";
const SenecPictogramHomeHeat = (props: Pick<SVGProps<SVGSVGElement>, "color">) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.4577 4.79224L40 15.6341V41H8V37C8 36.4477 8.44772 36 9 36C9.55228 36 10 36.4477 10 37V39H38V16.6775L24.4247 7.20775L10 16.695V32C10 32.5523 9.55228 33 9 33C8.44772 33 8 32.5523 8 32V15.6166L24.4577 4.79224Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18 19C18 19.3993 18.1465 19.7846 18.4118 20.083L19.0693 20.8227C20.8715 22.8502 20.3514 26.0224 17.9961 27.3682C16.7438 28.0839 16.4673 29.7705 17.4255 30.8485L18.083 31.5882C18.6737 32.2527 19 33.1109 19 34H17C17 33.6007 16.8535 33.2154 16.5882 32.9169L15.9307 32.1773C14.1285 30.1498 14.6486 26.9776 17.0039 25.6318C18.2562 24.9161 18.5327 23.2295 17.5745 22.1515L16.917 21.4118C16.3263 20.7473 16 19.8891 16 19H18Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.5714 19C24.5714 19.4297 24.7125 19.8476 24.9729 20.1894L25.6103 21.026C27.1439 23.0388 26.6602 25.9284 24.5547 27.332C23.4095 28.0955 23.1464 29.6671 23.9806 30.7619L24.618 31.5985C25.1438 32.2887 25.4286 33.1323 25.4286 34H23.4286C23.4286 33.5703 23.2875 33.1524 23.0271 32.8106L22.3897 31.974C20.8561 29.9612 21.3398 27.0716 23.4453 25.6679C24.5905 24.9045 24.8536 23.3329 24.0194 22.2381L23.382 21.4015C22.8562 20.7113 22.5714 19.8676 22.5714 19H24.5714Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M31 19C31 19.3993 31.1465 19.7846 31.4118 20.083L32.0693 20.8227C33.8715 22.8502 33.3514 26.0224 30.9961 27.3682C29.7438 28.0839 29.4673 29.7705 30.4255 30.8485L31.083 31.5882C31.6737 32.2527 32 33.1109 32 34H30C30 33.6007 29.8535 33.2154 29.5882 32.9169L28.9307 32.1773C27.1285 30.1498 27.6486 26.9776 30.0039 25.6318C31.2562 24.9161 31.5327 23.2295 30.5745 22.1515L29.917 21.4118C29.3263 20.7473 29 19.8891 29 19H31Z"
            fill="currentColor"
        />
    </svg>
);
export default SenecPictogramHomeHeat;
